export const initCycle = function () {

    let pourcentScroll = 0
    const hauteurVue = window.innerHeight
    const largeurVue = window.innerWidth
    const divCycle = document.querySelector('.bloc-accueil-cycle')
    const texte1 = document.querySelector('.cycle-texte1')
    const texte2 = document.querySelector('.cycle-texte2')
    const image1 = document.querySelector('.cycle-image1')
    const image2 = document.querySelector('.cycle-image2')
    const image3 = document.querySelector('.cycle-image3')
    const titre = document.querySelector('.cycle-phrase')

    window.onscroll = function () {

        const divCycle = document.querySelector('.bloc-accueil-cycle')
        const divPos = divCycle.getBoundingClientRect()


        pourcentScroll = ((-divPos.top + hauteurVue) * 100) / divPos.height
        

        
        // ! DESKTOP 

        if (largeurVue > 850) {

            // TEXTE CYCLE

            if (pourcentScroll < 10) {
                titre.style.opacity = 0

            }
            if (pourcentScroll >= 10) {
                titre.style.opacity = 1

            }
            if ((pourcentScroll > 0) && (pourcentScroll <= 100)) {
                titre.style.transform = "translateX(-50%) translateY(-50%) rotate(" + window.pageYOffset / 10 + "deg)";
                titre.style.width = (pourcentScroll * 2) + 50 + '%';
               // titre.style.opacity = 1
            }

            if (pourcentScroll > 90) {
                titre.style.opacity = 0

            }

            // TEXTE 1

            if (pourcentScroll < 20) {
                texte1.style.opacity = 0
                texte1.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                texte1.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 20) && (pourcentScroll <= 50)) {
                texte1.style.opacity = 1
                texte1.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                texte1.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 50) {
                texte1.style.opacity = 0
                texte1.style.transform = "  translateX(-50%) translateY(-50%) scale(2)"
                texte1.style.filter = 'blur(30px)'
            }


            // TEXTE 2

            if (pourcentScroll < 50) {
                texte2.style.opacity = 0
                texte2.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                texte2.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 50) && (pourcentScroll <= 80)) {
                texte2.style.opacity = 1
                texte2.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                texte2.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 80) {
                texte2.style.opacity = 0
                texte2.style.transform = "  translateX(-50%) translateY(-50%) scale(2)"
                texte2.style.filter = 'blur(30px)'
            }


            // IMAGE 1
            if (pourcentScroll < 10) {
                image1.style.opacity = 0
                image1.style.left = "50%"
                image1.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                image1.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 10) && (pourcentScroll <= 40)) {
                image1.style.opacity = .8
                image1.style.left = "80%"
                image1.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                image1.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 40) {
                image1.style.opacity = 0
                image1.style.left = "120%"
                image1.style.transform = "  translateX(-50%) translateY(-50%) scale(2)"
                image1.style.filter = 'blur(30px)'
            }


            // IMAGE 2
            if (pourcentScroll < 30) {
                image2.style.opacity = 0
                image2.style.left = "50%"
                image2.style.top = "50%"
                image2.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                image2.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 30) && (pourcentScroll <= 60)) {
                image2.style.opacity = .8
                image2.style.left = "20%"
                image2.style.top = "70%"
                image2.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                image2.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 60) {
                image2.style.opacity = 0
                image2.style.left = "-50%"
                image2.style.top = "90%"
                image2.style.transform = "  translateX(-50%) translateY(-50%) scale(2)"
                image2.style.filter = 'blur(30px)'
            }


            // IMAGE 
            if (pourcentScroll < 60) {
                image3.style.opacity = 0
                image3.style.left = "50%"
                image3.style.top = "50%"
                image3.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                image3.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 60) && (pourcentScroll <= 100)) {
                image3.style.opacity = .8
                image3.style.left = "20%"
                image3.style.top = "20%"
                image3.style.transform = "  translateX(-50%) translateY(-50%) scale(.8)"
                image3.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 100) {
                image3.style.opacity = 0
                image3.style.left = "-50%"
                image3.style.top = "-40%"
                image3.style.transform = "  translateX(-50%) translateY(-50%) scale(2)"
                image3.style.filter = 'blur(30px)'
            }

        } 
        else {

             // ! MOBILE

             // TEXTE CYCLE

            if (pourcentScroll < 5) {
                titre.style.opacity = 0
            }

            if (pourcentScroll > 5)   {
                titre.style.transform = "translateX(-50%) translateY(-50%) rotate(" + window.pageYOffset / 2 + "deg)";
            }

            if ((pourcentScroll > 5) && (pourcentScroll <= 40)) {
                
                titre.style.width = (pourcentScroll * 2) + 50 + '%';
                titre.style.opacity = 1
            }

            
            if ( pourcentScroll > 40 ) {
                titre.style.width = (pourcentScroll * 3) + 50 + '%';
                titre.style.opacity = .5
            }
            if ( pourcentScroll > 50 ) {
                titre.style.width = (pourcentScroll * 4) + 50 + '%';
                titre.style.opacity = .5
            }
            if ( pourcentScroll > 60 ) {
                titre.style.width = (pourcentScroll * 5) + 50 + '%';
                titre.style.opacity = .5
            }
            if ( pourcentScroll > 70 ) {
                titre.style.width = (pourcentScroll * 6) + 50 + '%';
                titre.style.opacity = .5
            }


            if (pourcentScroll > 90) {
                titre.style.opacity = 0

            }

            // TEXTE 1

            if (pourcentScroll < 40) {
                texte1.style.opacity = 0
                texte1.style.left = "50%"
                texte1.style.top = "50%"
                texte1.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                texte1.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 40) && (pourcentScroll <= 70)) {
                texte1.style.left = "45%"
                texte1.style.top = "45%"
                texte1.style.opacity = 1
                texte1.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                texte1.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 60) {
                texte1.style.left = "30%"
                texte1.style.top = "30%"
                texte1.style.opacity = 0
                texte1.style.transform = "  translateX(-50%) translateY(-50%) scale(2)"
                texte1.style.filter = 'blur(30px)'
            }


            // TEXTE 2

            if (pourcentScroll < 60) {
                texte2.style.left = "50%"
                texte2.style.top = "50%"
                texte2.style.opacity = 0
                texte2.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                texte2.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 70) && (pourcentScroll <= 100)) {
                texte2.style.left = "45%"
                texte2.style.top = "60%"
                texte2.style.opacity = 1
                texte2.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                texte2.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 100) {
                texte2.style.left = "30%"
                texte2.style.top = "100%"
                texte2.style.opacity = 0
                texte2.style.transform = "  translateX(-50%) translateY(-50%) scale(2)"
                texte2.style.filter = 'blur(30px)'
            }


            // IMAGE 1
            if (pourcentScroll < 20) {
                image1.style.opacity = 0
                image1.style.left = "50%"
                image1.style.top = "50%"
                image1.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                image1.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 20) && (pourcentScroll <= 40)) {
                image1.style.opacity = .8
                image1.style.left = "80%"
                image1.style.top = "80%"
                image1.style.transform = "  translateX(-50%) translateY(-50%) scale(.4)"
                image1.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 40) {
                image1.style.opacity = 0
                image1.style.left = "120%"
                image1.style.top = "120%"
                image1.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                image1.style.filter = 'blur(30px)'
            }


            // IMAGE 2
            if (pourcentScroll < 40) {
                image2.style.opacity = 0
                image2.style.left = "50%"
                image2.style.top = "50%"
                image2.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                image2.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 40) && (pourcentScroll <= 60)) {
                image2.style.opacity = .8
                image2.style.left = "40%"
                image2.style.top = "90%"
                image2.style.transform = "  translateX(-50%) translateY(-50%) scale(.4)"
                image2.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 60) {
                image2.style.opacity = 0
                image2.style.left = "-50%"
                image2.style.top = "120%"
                image2.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                image2.style.filter = 'blur(30px)'
            }


            // IMAGE 
            if (pourcentScroll < 70) {
                image3.style.opacity = 0
                image3.style.left = "50%"
                image3.style.top = "30%"
                image3.style.transform = "  translateX(-50%) translateY(-50%) scale(0)"
                image3.style.filter = 'blur(30px)'
            }
            if ((pourcentScroll >= 70) && (pourcentScroll <= 100)) {
                image3.style.opacity = .8
                image3.style.left = "20%"
                image3.style.top = "15%"
                image3.style.transform = "  translateX(-50%) translateY(-50%) scale(.3)"
                image3.style.filter = 'blur(0px)'
            }
            if (pourcentScroll > 100) {
                image3.style.opacity = 0
                image3.style.left = "-50%"
                image3.style.top = "-40%"
                image3.style.transform = "  translateX(-50%) translateY(-50%) scale(1)"
                image3.style.filter = 'blur(30px)'
            }

        }

    }
}

// function convertToRange(value, srcRange, dstRange){
//     // value is outside source range return
//     if (value < srcRange[0] || value > srcRange[1]){
//       return NaN;
//     }
//     var srcMax = srcRange[1] - srcRange[0],
//         dstMax = dstRange[1] - dstRange[0],
//         adjValue = value - srcRange[0];

//     return (adjValue * dstMax / srcMax) + dstRange[0];
//   }